/**
 * A telefonos statisztika szuroi a cimben (lasd phone-stats.tsx).
 *
 * Kulon fajlban, hogy a router az ellenorzot azonnal ismerje, maga az oldal
 * viszont csak megnyitaskor toltodjon le (K2, 4. csomag).
 */
export interface PhoneStatsSearch {
  from?: string;
  to?: string;
  users?: string;
  dir?: 'inbound' | 'outbound';
}

export function validatePhoneStatsSearch(search: Record<string, unknown>): PhoneStatsSearch {
  const date = (value: unknown) =>
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined;
  const out: PhoneStatsSearch = {};
  const from = date(search.from);
  const to = date(search.to);
  if (from) out.from = from;
  if (to) out.to = to;
  if (typeof search.users === 'string' && search.users) out.users = search.users;
  if (search.dir === 'inbound' || search.dir === 'outbound') out.dir = search.dir;
  return out;
}
